// extracted by mini-css-extract-plugin
export default {"PinIcon":"styles_PinIcon__EnV9j","pinned":"styles_pinned__9VJTh"};